export default "__VITE_ASSET__D2Dlqe2C__"